import React from 'react';

import SearchContainer from '../../features/Search/Search';

const SponsorSearchPage: React.FC = () => <SearchContainer />;

export default SponsorSearchPage;
